module.exports = __webpack_public_path__ + "static/media/IMG_9519.c13bdee4.JPG";